import { projectIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadProject } from "../projects/loaders.ts";
import { ProjectPending } from "../projects/pending.tsx";
import { ProjectPage } from "../projects/project-page.tsx";
import { tabBodies } from "../projects/tab-bodies.ts";
import { isSectionShown, sections } from "../shell/navigation.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { projectSearch, projectTabSchema } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/projects/$id/{-$tab}");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id, tab } = route.useParams();
  return viewer === null || !isSectionShown(sections.projects, viewer.role) ? (
    <NoAccessPage />
  ) : (
    <ProjectPage viewer={viewer} projectId={id} tab={tab ?? "overview"} />
  );
};

export const Route = createFileRoute("/_app/projects/$id/{-$tab}")({
  params: {
    parse: ({ id, tab }) => ({
      id: parameterOrNotFound(projectIdSchema, id),
      tab: parameterOrNotFound(projectTabSchema.exclude(["overview"]).optional(), tab),
    }),
    stringify: ({ id, tab }) => ({ id, tab }),
  },
  validateSearch: projectSearch,
  loader: async ({ context, params }) => {
    await Promise.all([loadProject(context.data, params.id), tabBodies[params.tab ?? "overview"].preload()]);
  },
  pendingComponent: ProjectPending,
  component: Page,
});
